import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('drapcode-card-traits', (editor, opts = {}) => {
  const default_labels = {
    card: 'Card',
    card_full: 'Full Card',
    card_image: 'Image Card',
    card_body: 'Card Body',
    card_header: 'Card Header',
    card_footer: 'Card Footer',
  };
  const default_types = {
    card: 'card',
    card_full: 'card-full',
    card_image: 'card-image',
    card_body: 'card-body',
    card_header: 'card-header',
    card_footer: 'card-footer',
  };
  let options = {
    ...{
      labels: default_labels,
      types: default_types,
    },
    ...opts,
  };

  loadTraits(editor, options);
});
